module.exports = __webpack_public_path__ + "static/media/vaccine_p3_2.c628bd2e.png";